// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/razzle/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3b5518825eac3482dad5927e66b12799-scss{text-align:center;display:grid;gap:5px}._09825d7b25dc262a9b5b3f5090f5c770-scss:hover{background:none !important}.c99b4f74a5ce572f8baefa55936747c5-scss{-o-object-fit:scale-down !important;object-fit:scale-down !important}._2b6712fcce2a0a298fa5ba314a8bf44c-scss{color:var(--primary-main);font-size:20px}\n", ""]);
// Exports
exports.locals = {
	"link": "_3b5518825eac3482dad5927e66b12799-scss",
	"cardContainer": "_09825d7b25dc262a9b5b3f5090f5c770-scss",
	"image": "c99b4f74a5ce572f8baefa55936747c5-scss",
	"title": "_2b6712fcce2a0a298fa5ba314a8bf44c-scss"
};
module.exports = exports;
